import { create } from 'zustand';
import { AccountApi, ApiUtils, RequestStrategyEnum } from '@shared/api';

interface IRejectRequestStore {
  loading: boolean;
  error: string | null;
  success: boolean;
  rejectRequest: (requestId: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useRejectRequestStore = create<IRejectRequestStore>((set) => ({
  loading: false,
  error: null,
  success: false,

  rejectRequest: ApiUtils.wrapperApi(async (requestId: string, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      await AccountApi.rejectRequest(requestId, signal);
      set({ success: true, loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ success: false, loading: false, error: null }),
}));
